import {
  useQuery,
  UseQueryOptions,
  InvalidateQueryFilters,
  useQueryClient,
} from '@tanstack/react-query'
import { getTaxonomyTranslations } from '@global/api/taxonomy-translations'
import {
  TaxonomyTranslationPaginationParams,
  TaxonomyTranslationPaginationResponse,
} from '@taxonomy-translation/types'

const THREE_MINUTES = 180_000

const buildQueryKey = (params?: TaxonomyTranslationPaginationParams) =>
  ['taxonomy-translations', 'pagination', params].filter(v => !!v)

export const useTaxonomyTranslations = (
  params: TaxonomyTranslationPaginationParams = {},
  options: UseQueryOptions<TaxonomyTranslationPaginationResponse> = {},
) =>
  useQuery({
    queryKey: buildQueryKey(params),
    queryFn: ({ signal }) => getTaxonomyTranslations(params, signal),
    staleTime: THREE_MINUTES,
    refetchOnWindowFocus: false,
    ...options,
  })

export const useInvalidateTaxonomyTranslations = (
  params?: TaxonomyTranslationPaginationParams,
  filters: Omit<InvalidateQueryFilters, 'queryKey'> = {},
) => {
  const queryClient = useQueryClient()
  const queryKey = buildQueryKey(params)

  return () =>
    queryClient.invalidateQueries({
      ...filters,
      queryKey,
    })
}
